<div *transloco="let t" class="bulb-share-icons-container">
    <a
        *ngFor="let shareService of shareServices | keyvalue: shareServicesOrder"
        [ngClass]="{'bulb-share-icons-container__icon--disabled' : shareService.value.isDisabled }"
        class="bulb-share-icons-container__icon"
        title="{{ t(shareService.value.disabledReason) }}"
        [href]="shareService.value.isDisabled ? 'javascript:undefined' : shareService.value.href"
        target="{{ shareService.value.isDisabled ? '' : '_blank' }}"
    >
        <svg-icon
            [key]="shareService.value.svgIconKey"
            fontSize="1.5rem"
        >
        </svg-icon>
    </a>
</div>
